import * as React from 'react';

interface IAdBannerPlaceholderProps {
  sizes: { width: string; height: number };
  testId?: string;
  children?: React.ReactNode;
}

/**
 * Резервирует место под баннер (по размерам размещения), чтобы избежать сдвига контента (CLS),
 * пока реклама грузится на клиенте.
 */
export const AdBannerPlaceholder: React.FC<IAdBannerPlaceholderProps> = ({ sizes, testId, children }) => {
  return (
    <div style={{ width: sizes.width, height: sizes.height, minHeight: sizes.height }} data-testid={testId}>
      {children}
    </div>
  );
};
